const validator = {
    validateEmail: (email: string): boolean => {
        const re =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/;

        return re.test(email);
    },
    validateUrl: (url: string): boolean => {
        const re =
            /^(https?:\/\/)?([\w\-]+(\.[\w\-]+)+)(:\d+)?(\/\S*)?$/;

        return re.test(url);
    }
};

export default validator;
